import React, { Component } from 'react';
import './ToggleButton.sass';
import PropTypes from 'prop-types';

class ToggleButton extends Component {
    constructor(props){
        super(props);
        this.state = { activeSide: 'Right'};
    
    }

    componentDidMount(){
        this.setState({activeSide: 'Right'});
    }

    setActiveSide = (activeSide) => {
        this.setState({activeSide: activeSide});

        this.sendActiveSide(activeSide);
    }

    sendActiveSide = (activeSide) => {
        this.props.onSelectActive(activeSide);
    }

    render() {
        
        const leftText = this.props.leftText || ' ';
        const rightText = this.props.rightText || ' ';
                
        var html =  <div className = "toggle">
            <input type = "radio" className = "toggleInput" name = "view2" value = "left" id = "left" />
            <label htmlFor = "left" className = "toggleLabel toggleLeft" onClick = {() => this.setActiveSide('Left')} > <div className = "toggleText"> {leftText} </div> </label>
            <input type = "radio" className = "toggleInput" name = "view2" value = "right" id = "right" defaultChecked />
            <label htmlFor = "right" className = "toggleLabel toggleRight" onClick = {() => this.setActiveSide('Right')} > <div className = "toggleText"> {rightText} </div> </label>
            <span className = "toggleSelection"></span>
        </div>;
        return html;
    }
}

ToggleButton.propTypes = {
    leftText: PropTypes.string,
    rightText: PropTypes.string,
};

export default ToggleButton;